import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticStyle: {
      "padding": "0"
    }
  }, [_c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showCalculatorCA,
      "max-width": "360px"
    },
    on: {
      "close": function ($event) {
        _vm.showCalculatorCA = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-check"
          },
          on: {
            "click": _vm.applyCalculatorCA
          }
        })];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCheckbox, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.lowHighBytes'),
      "color": _vm.color
    },
    on: {
      "change": function ($event) {
        return _vm.calculateAddressCA();
      }
    },
    model: {
      value: _vm.calculatorCA.lowHighBytes,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorCA, "lowHighBytes", $$v);
      },
      expression: "calculatorCA.lowHighBytes"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "min": "0",
      "label": "CA 1 (Byte 1)",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.calculateAddressCA();
      }
    },
    model: {
      value: _vm.calculatorCA.ca1,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorCA, "ca1", $$v);
      },
      expression: "calculatorCA.ca1"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "min": "0",
      "label": "CA 2 (Byte 2)",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.calculateAddressCA();
      }
    },
    model: {
      value: _vm.calculatorCA.ca2,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorCA, "ca2", $$v);
      },
      expression: "calculatorCA.ca2"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.resultCA')) + ": " + _vm._s(_vm.calculatorCA.result) + "\n      ")], 1)], 1)], 1), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.showCalculatorIOA,
      "max-width": "360px"
    },
    on: {
      "close": function ($event) {
        _vm.showCalculatorIOA = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-check"
          },
          on: {
            "click": _vm.applyCalculatorIOA
          }
        })];
      },
      proxy: true
    }])
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VCheckbox, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Consumers.detail.lowHighBytes'),
      "color": _vm.color
    },
    on: {
      "change": function ($event) {
        return _vm.calculateAddressIOA();
      }
    },
    model: {
      value: _vm.calculatorIOA.lowHighBytes,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorIOA, "lowHighBytes", $$v);
      },
      expression: "calculatorIOA.lowHighBytes"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "min": "0",
      "label": "IOA 1 (Byte 1)",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.calculateAddressIOA();
      }
    },
    model: {
      value: _vm.calculatorIOA.ioa1,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorIOA, "ioa1", $$v);
      },
      expression: "calculatorIOA.ioa1"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "min": "0",
      "label": "IOA 2 (Byte 2)",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.calculateAddressIOA();
      }
    },
    model: {
      value: _vm.calculatorIOA.ioa2,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorIOA, "ioa2", $$v);
      },
      expression: "calculatorIOA.ioa2"
    }
  }), _c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "min": "0",
      "label": "IOA 3 (Byte 3)",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    on: {
      "input": function ($event) {
        return _vm.calculateAddressIOA();
      }
    },
    model: {
      value: _vm.calculatorIOA.ioa3,
      callback: function ($$v) {
        _vm.$set(_vm.calculatorIOA, "ioa3", $$v);
      },
      expression: "calculatorIOA.ioa3"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.resultIOA')) + ": " + _vm._s(_vm.calculatorIOA.result) + "\n      ")], 1)], 1)], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.commonAddress'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "append-icon": "fal fa-calculator"
    },
    on: {
      "click:append": function ($event) {
        return _vm.handleShowCalculatorCA();
      }
    },
    model: {
      value: _vm.internalValue.ca,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "ca", _vm._n($$v));
      },
      expression: "internalValue.ca"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.infomationObjectAddress'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto",
      "append-icon": "fal fa-calculator"
    },
    on: {
      "click:append": function ($event) {
        return _vm.handleShowCalculatorIOA();
      }
    },
    model: {
      value: _vm.internalValue.ioa,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "ioa", _vm._n($$v));
      },
      expression: "internalValue.ioa"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.type'),
      "items": _vm.types,
      "item-text": "typeString",
      "item-value": "type",
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto"
    },
    on: {
      "change": function ($event) {
        return _vm.changeTypeHandler(_vm.internalValue.type);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(data.item.typeString))]), _c(VListItemSubtitle, [_c('span', {
          staticClass: "font-weight-medium"
        }, [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Consumers.detail.decimal')))]), _vm._v("\n              " + _vm._s(data.item.type) + "\n            ")]), _c(VListItemSubtitle, [_vm._v(_vm._s(data.item.descr))])], 1)];
      }
    }]),
    model: {
      value: _vm.internalValue.type,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "type", $$v);
      },
      expression: "internalValue.type"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.deadBand'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto"
    },
    model: {
      value: _vm.internalValue.db,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "db", _vm._n($$v));
      },
      expression: "internalValue.db"
    }
  })], 1), _vm.showLimitsInput(_vm.internalValue.type) ? _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.lowerLimit'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto"
    },
    on: {
      "input": function ($event) {
        return _vm.inputAdjust('lowerLimit', _vm.internalValue.lowerLimit);
      }
    },
    model: {
      value: _vm.internalValue.lowerLimit,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "lowerLimit", _vm._n($$v));
      },
      expression: "internalValue.lowerLimit"
    }
  })], 1) : _vm._e(), _vm.showLimitsInput(_vm.internalValue.type) ? _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.upperLimit'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto"
    },
    on: {
      "input": function ($event) {
        return _vm.inputAdjust('upperLimit', _vm.internalValue.upperLimit);
      }
    },
    model: {
      value: _vm.internalValue.upperLimit,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "upperLimit", _vm._n($$v));
      },
      expression: "internalValue.upperLimit"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "type": "number",
      "min": "0",
      "max": "99999999",
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.validityPeriod'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "auto"
    },
    on: {
      "input": function ($event) {
        return _vm.inputAdjust('validityPeriod', _vm.internalValue.validityPeriod);
      }
    },
    model: {
      value: _vm.internalValue.validityPeriod,
      callback: function ($$v) {
        _vm.$set(_vm.internalValue, "validityPeriod", _vm._n($$v));
      },
      expression: "internalValue.validityPeriod"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };